import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-0546b338"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "operation-plan-warp"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "content-container"
};
const _hoisted_4 = {
  class: "table-container"
};
const _hoisted_5 = {
  class: "cms-card-block"
};
const _hoisted_6 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_8 = ["onDblclick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "mg-b--5"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "tips"
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import AddOperationPlan from '../AddOperationPlan/index.vue';
import UploadImage from '../components/UploadImage/index.vue';
import { OperationStateObjNew, RELEASE_COLOR_NEW, RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { elMessage } from '@/utils';
import { safeOpenUrl } from '@/utils/sanitize';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import { nextTick, inject, provide } from 'vue';
import { useVodLanguages } from '@/utils/cacheData';
import { messageBox } from '@/utils/validate';
import { removePropertyOfNull } from '@/utils/tools';
import { getOperationPlanThemeItemApi, uploadVodplusThemeItemPictureApi, deleteVodplusThemeItemPlanApi, editVodplusThemeItemPlanApi } from '@/api/vodNew';
import { getDynamicPlanThemeItemApi, uploadDynamicPlanThemeItemImgApi, deleteDynamicPlanThemeItemApi, editDynamicPlanThemeItemApi } from '@/api/topic';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'updateData'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const currentVodPlusItem = inject('currentVodPlusItem');
    const tooltipContent = ref(t('双击可以编辑执行时间'));
    const posterTypeObj = {
      common: t('通用'),
      android: t('安卓'),
      mobile: t('手机'),
      horizontal: t('横版'),
      vertical: t('竖版')
    };
    const uploadFormRef = ref(null);
    const datePickRef = ref(null);
    const inputRef = ref(null);
    const showUploadImage = ref(false);
    const tableRowData = inject('tableRowData');
    const addOperationPlan = reactive({
      visible: false
    });
    const STATUS_FIELD = inject('STATUS_FIELD'); // headerConfig

    const headerConfig = ref({
      title: '运营计划',
      btnList: [{
        label: '返回',
        func: () => {
          emit('update:modelValue', false);
          emit('updateData');
        }
      }]
    });
    const searchConfig = reactive({
      formList: [{
        label: '状态',
        prop: 'status',
        widgetType: 'Select',
        translation: true,
        list: OperationStateObjNew
      }, {
        label: '名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入名称',
        maxlength: 50
      }],
      formData: {
        status: '',
        name: ''
      },
      handleSearch: () => {
        getOperationPlanThemeItem();
      },
      handleReset: () => {
        tableConfig.paginationConfig.page = 1;
        getOperationPlanThemeItem();
      }
    });
    const tableConfig = reactive({
      currentTagtype: '',
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      // isShowHeader: false,
      headerButtonsList: [{
        label: '添加',
        func: () => {
          addOperationPlan.visible = true;
        }
      }, {
        label: '删除',
        type: 'danger',
        func: async () => {
          if (selectTableConfig.selectData.length === 0) return elMessage('warning', '请先勾选需要删除的运营计划');
          if (selectTableConfig.selectData.filter(item => item.status == 'running').length) return elMessage('warning', '存在执行中的运营计划，不允许删除');
          let idList = selectTableConfig.selectData.map(item => item.id);
          const {
            type
          } = currentVodPlusItem.value;
          messageBox('确定删除所选数据吗?').then(async () => {
            const {
              code,
              data
            } = type === 'staic' ? await deleteVodplusThemeItemPlanApi(idList) : await deleteDynamicPlanThemeItemApi(idList);

            if (code == 0) {
              elMessage('success', '删除成功');
              getOperationPlanThemeItem();
            }
          });
        }
      }],
      config: {
        loading: false
      },
      'row-key': row => {
        return row.programId;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '序号',
        prop: 'serial',
        width: 70
      }, {
        label: '状态',
        prop: 'status',
        width: 120,
        formatter: value => {
          if (value != undefined && value != null) {
            return `<span style="color: ${STATUS_FIELD[value].color}">${STATUS_FIELD[value].value}</span>`;
          }
        }
      }, {
        label: '内容名称',
        prop: 'name',
        width: 200
      }, {
        label: '执行时间',
        prop: 'executionTime',
        cellSlot: true,
        width: 320
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        width: 130,
        formatter: val => {
          return `<span style='color: ${RELEASE_COLOR_NEW[val]}'>${val !== undefined && t(RELEASE_STATUS_NEW[val])}</span>`;
        }
      }, {
        label: '语言',
        prop: 'language',
        width: 100
      }, // {
      //     label: '付费类别', prop: 'payType',
      //     // formatter: (value: any) => {
      //     // }
      // },
      {
        label: '内容类型',
        prop: 'contentType',
        width: 130,
        formatter: value => {
          if (value !== undefined) {
            return value == 'movie' ? t('单片') : value == 'tv_series' ? t('剧集') : t('系列片');
          }
        }
      }, {
        label: '付费形式',
        prop: 'paymentForm',
        width: 162,
        sortable: 'custom',
        formatter: value => {
          return value == 'vip' ? t('VIP内容') : value == 'single_pay' ? t('付费单片') : value == 'free' ? t('免费内容') : '';
        }
      }, {
        label: '终端审核',
        prop: 'terminalCheck',
        cellSlot: true,
        width: 100
      }, {
        label: '推荐图',
        prop: 'imgUrl',
        cellSlot: true,
        showOverflowTooltip: false
      }, {
        label: '操作',
        showOverflowTooltip: false,
        prop: '',
        widgetType: 'buttons',
        fixed: 'right',
        buttonsList: [{
          label: '删除',
          func: row => {
            const {
              id
            } = row;
            const {
              type
            } = currentVodPlusItem.value;
            console.log('type', type);
            messageBox('确定删除所选数据吗?').then(async () => {
              const {
                code
              } = type === 'static' ? await deleteVodplusThemeItemPlanApi([id]) : await deleteDynamicPlanThemeItemApi([id]);

              if (code == '0') {
                elMessage('success', '删除成功');
                getOperationPlanThemeItem();
              }
            });
          },
          controller: row => {
            return row.status != 'running';
          }
        }, {
          label: '启动',
          func: row => {
            const {
              id
            } = row;
            editVodplusThemeItemPlan({
              id,
              status: 'running'
            });
          },
          controller: row => {
            return row.status != 'running';
          }
        }, {
          label: '结束',
          func: row => {
            const {
              id
            } = row;
            editVodplusThemeItemPlan({
              id,
              status: 'end'
            });
          },
          controller: row => {
            return row.status == 'running';
          }
        }, {
          label: '上传图片',
          func: row => {
            uploadImgParams.value.formData = row.pictureList.map(item => {
              return { ...item,
                imgUrl: item.imageUrl
              };
            }) || [];
            uploadImgParams.value.id = row.id;
            uploadImgParams.value.programType = row.contentType;
            uploadImgParams.value.sourceId = row.sourceId;
            showUploadImage.value = true;
          }
        }]
      }]
    });
    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    });
    const shortcuts = ref([{
      text: t('不限'),
      value: () => {
        // editCell.value = ''
        return [null, null];
      }
    }]); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    };

    const onDateChange = (date, value) => {
      // console.log(date, value);
      // console.log(date[0], date[1]);
      // console.log(JSON.stringify(date[0]) === '"Invalid Date"');
      let item = tableConfig.data.find(item => item.id === value.id);

      if (JSON.stringify(date[0]) === '"Invalid Date"' && JSON.stringify(date[1]) === '"Invalid Date"') {
        item.executionTime = t('不限');
        editVodplusThemeItemPlan({
          id: value.id,
          scheduleStartTime: '0000-00-00 00:00:00',
          scheduleEndTime: '0000-00-00 00:00:00'
        });
      } else {
        editVodplusThemeItemPlan({
          id: value.id,
          scheduleStartTime: item.executionTime[0],
          scheduleEndTime: item.executionTime[1]
        });
      }
    };

    const editCell = ref('');

    const onEditCell = scope => {
      editCell.value = `${scope.$index}-${scope.column.no}`;
      nextTick(() => {
        const input = document.querySelector('.el-range-input');
        input.focus();
      });
    }; // 修改排序输入框获取焦点事件


    const onSIndexFocus = row => {
      // 因为编辑时会改变之前的 index，所以要记住之前的 index
      tableConfig.oldIndex = row.executionTime;
    }; // 修改排序输入框丢失焦点事件


    const onSIndexBlur = async row => {
      // console.log(row);
      let executionTime = row.executionTime;

      if (row.executionTime !== tableConfig.oldIndex) {
        try {
          editCell.value = '';
        } catch (error) {
          row.executionTime = tableConfig.executionTime;
        }
      } else {
        editCell.value = '';
      }
    };

    const datePickVisibleChange = visible => {
      // console.log(visible);
      if (!visible) {
        nextTick(() => {
          inputRef.value.focus();
        });
      }
    };

    const formateTime = dateArr => {
      // console.log(dateArr);
      if (typeof dateArr === 'object') {
        return dateArr[0] + '-' + dateArr[1];
      }

      return dateArr;
    }; // 推荐图点击打开新页面


    const recommendImageClick = imgUrl => {
      const url = safeOpenUrl(imgUrl);
      if (url) window.open(url);
    };

    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      languageOptions.value = res;
    };

    const uploadImgParams = ref({
      id: null,
      programType: '',
      sourceId: undefined,
      formData: []
    });
    provide('uploadImgParams', uploadImgParams);

    const onUploadImageComfirm = async (params, done) => {
      try {
        let pictureList = JSON.parse(JSON.stringify(params));
        pictureList.forEach(item => {
          delete item.file;

          if (item.type == 0 || item.type == 2) {
            //输入url || 图库选图
            delete item.base64Image;
            delete item.type;
            delete item.imgUrl;
            delete item.imageUrl;
          } else {
            // 上传
            item.base64Image = item.base64Image.split('base64,')[1];
            delete item.url;
            delete item.type;
            delete item.imgUrl;
            delete item.imageUrl;
          }

          item.vodplusThemeItemScheduleId = uploadImgParams.value.id;
        });
        console.log('提交的参数-457', pictureList); // 推荐位(类型 by topic/All) 上传图片调用接口

        const {
          type
        } = currentVodPlusItem.value;
        const res = type === 'static' ? await uploadVodplusThemeItemPictureApi(pictureList) : await uploadDynamicPlanThemeItemImgApi(pictureList);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          getOperationPlanThemeItem();
          done();
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    }; // 获取运营方案主题内容


    const getOperationPlanThemeItem = async () => {
      tableConfig.config.loading = true;
      const {
        operationPlanThemeId,
        themeTemplateId,
        themeSubitemId
      } = tableRowData.value;

      try {
        if (operationPlanThemeId != null && themeTemplateId != null && themeSubitemId != null) {
          const {
            type,
            childMode
          } = currentVodPlusItem.value;
          let params = { ...searchConfig.formData,
            vodplusThemeItemId: themeSubitemId,
            pageNo: tableConfig.paginationConfig.page,
            pageSize: tableConfig.paginationConfig.limit,
            childMode: type === 'static' ? undefined : childMode
          };
          const {
            code,
            data
          } = type === 'static' ? await getOperationPlanThemeItemApi(removePropertyOfNull(params)) : await getDynamicPlanThemeItemApi(removePropertyOfNull(params));

          if (code == '0') {
            let remoteData = type === 'static' ? data.data : data.records;
            tableConfig.data = remoteData ? remoteData.map((item, index) => {
              return { ...item,
                serial: index + 1,
                executionTime: item.scheduleStartTime == '0000-00-00 00:00:00' && item.scheduleEndTime == '0000-00-00 00:00:00' ? t('不限') : [item.scheduleStartTime, item.scheduleEndTime]
              };
            }) : [];
            tableConfig.paginationConfig.total = data.total; //console.log('tableConfig.data----501', tableConfig.data)
          }
        }
      } catch (error) {
        console.log('516-ERROR', error);
      }

      tableConfig.config.loading = false;
    };

    const handleSwitchChange = row => {
      tableConfig.config.loading = true;
      return new Promise(async (resolve, reject) => {
        try {
          const {
            id
          } = row;
          const {
            operationPlanThemeId,
            themeTemplateId,
            themeSubitemId
          } = tableRowData.value;
          const {
            type
          } = currentVodPlusItem.value;
          let postData = {
            id,
            terminalCheck: row.terminalCheck == 'uncheck' ? 'checked' : 'unchecked',
            vodplusDynamicThemeComponentItemId: type === 'static' ? undefined : themeSubitemId
          };
          const res = type === 'static' ? await editVodplusThemeItemPlanApi(postData) : await editDynamicPlanThemeItemApi(postData);

          if (res.code == '0') {
            setTimeout(() => {
              elMessage('success', '操作成功');
              getOperationPlanThemeItem();
              return resolve(true);
            }, 200);
          } else {
            setTimeout(() => {
              tableConfig.config.loading = false;
              return reject(false);
            }, 200);
          }
        } catch (error) {
          // console.log(error);
          setTimeout(() => {
            elMessage('error', '');
            tableConfig.config.loading = false;
            return reject(false);
          }, 200);
        }
      });
    };

    const editVodplusThemeItemPlan = async (params, done) => {
      try {
        const {
          type
        } = currentVodPlusItem.value;
        const {
          themeSubitemId
        } = tableRowData.value;
        params.vodplusDynamicThemeComponentItemId = type === 'dynamic' ? themeSubitemId : undefined;
        const res = type === 'static' ? await editVodplusThemeItemPlanApi(params) : await editDynamicPlanThemeItemApi(params); // console.log(res);

        if (res.code === '0') {
          nextTick(() => {
            elMessage('success', '操作成功');
          });
          done && done();
        }
      } catch (error) {}

      editCell.value = '';
      getOperationPlanThemeItem();
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = columnConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    watch(() => props.modelValue, val => {
      if (val) {
        getAllLanguages();
        getOperationPlanThemeItem();
      }
    });
    watch(() => addOperationPlan.visible, val => {
      if (!val) {
        getOperationPlanThemeItem();
      }
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [!addOperationPlan.visible ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.handleSearch,
        onReset: searchConfig.handleReset
      }, null, 8, ["form-list", "form-data", "onSearch", "onReset"]), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_common_table, {
        "show-title": false,
        "option-column-list": columnConfig.columnList,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getOperationPlanThemeItem,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'executionTime' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            content: tooltipContent.value,
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          }, 8, ["content"])])) : _createCommentVNode("", true)]),
          cellSlot: _withCtx(scope => [scope.column.property === 'executionTime' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [editCell.value != `${scope.$index}-${scope.column.no}` ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            style: {
              "display": "inline-block",
              "width": "100%"
            },
            class: "pointer executionTime",
            onDblclick: $event => onEditCell(scope)
          }, _toDisplayString(formateTime(scope.row.executionTime)), 41, _hoisted_8)) : (_openBlock(), _createBlock(_component_el_date_picker, {
            key: 1,
            ref_key: "datePickRef",
            ref: datePickRef,
            onChange: date => onDateChange(date, scope.row),
            style: {
              "width": "100%"
            },
            class: "EL__focus",
            modelValue: scope.row.executionTime,
            "onUpdate:modelValue": $event => scope.row.executionTime = $event,
            type: "daterange",
            "unlink-panels": "",
            "range-separator": "To",
            "start-placeholder": "Start date",
            "end-placeholder": "End date",
            shortcuts: shortcuts.value,
            onBlur: $event => onSIndexBlur(scope.row),
            onFocus: onSIndexFocus,
            onVisibleChange: datePickVisibleChange,
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "shortcuts", "onBlur"]))], 64)) : scope.column.property === 'terminalCheck' ? (_openBlock(), _createBlock(_component_el_switch, {
            key: 1,
            disabled: scope.row.status == 'running',
            "before-change": () => handleSwitchChange(scope.row),
            "active-value": 'checked',
            "inactive-value": 'uncheck',
            modelValue: scope.row.terminalCheck,
            "onUpdate:modelValue": $event => scope.row.terminalCheck = $event
          }, null, 8, ["disabled", "before-change", "modelValue", "onUpdate:modelValue"])) : scope.column.property === 'imgUrl' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [scope.row.pictureList && scope.row.pictureList.length ? (_openBlock(), _createBlock(_component_el_popover, {
            key: 0,
            width: 154,
            trigger: "hover",
            placement: "top"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.pictureList || [], (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index + '_c'
              }, [_createElementVNode("div", {
                class: "link",
                onClick: $event => recommendImageClick(item.imageUrl),
                style: {
                  "white-space": "nowrap",
                  "text-overflow": "ellipsis",
                  "overflow": "hidden"
                }
              }, _toDisplayString(item.imageUrl), 9, _hoisted_9)]);
            }), 128))])]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.pictureList || [], (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, _toDisplayString(posterTypeObj[item.posterType] ? posterTypeObj[item.posterType] : ''), 1), _createElementVNode("img", {
                style: {
                  "width": "100%",
                  "height": "100%"
                },
                src: item.imageUrl,
                alt: ""
              }, null, 8, _hoisted_11)])]);
            }), 128))]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config"])])])), [[_directive_loading, tableConfig.config.loading]])]), _createVNode(UploadImage, {
        modelValue: showUploadImage.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showUploadImage.value = $event),
        "form-data": uploadImgParams.value.formData,
        onOnComfirm: onUploadImageComfirm
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('推荐位尺寸图片上传提示', {
          size: _unref(tableRowData).size
        })), 1)]),
        _: 1
      }, 8, ["modelValue", "form-data"])])) : _createCommentVNode("", true), addOperationPlan.visible ? (_openBlock(), _createBlock(AddOperationPlan, {
        key: 1,
        returnBackFn: () => addOperationPlan.visible = false
      }, null, 8, ["returnBackFn"])) : _createCommentVNode("", true), _createElementVNode("input", {
        style: {
          "display": "block",
          "z-index": "-9999999",
          "background-color": "transparent",
          "border": "none",
          "position": "absolute",
          "bottom": "0"
        },
        type: "text",
        ref_key: "inputRef",
        ref: inputRef
      }, null, 512)])) : _createCommentVNode("", true);
    };
  }

});